package com.essntl.features.task.ui.addedittask

interface AddEditTaskNavigation {
    data class EditItinerary(val itineraryId: String) : AddEditTaskNavigation
    data object NavigateBack : AddEditTaskNavigation
}